export const Operators = [
    {
      code: 'lk',
      name: 'Contains',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars'],
      defaultSelected:true
    },
    {
      code: 'in',
      name: 'Includes',
      validFor:['*']
    },
    {
      code: 'nlk',
      name: 'Does not Contains',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars']
    },
    {
      code: 'bw',
      name: 'Begins With',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars']
    },
    {
      code: 'nbw',
      name: 'Does not Begin With',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars']
    },
    {
      code: 'ew',
      name: 'Ends With',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars']
    },
    {
      code: 'dnew',
      name: 'Does not Ends With',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars']
    },
    {
      code: 'lt',
      name: 'Less than',
      validFor:['onlyNumeric','onlyDigital']
    },
    {
      code: 'gt',
      name: 'Greater than',
      validFor:['onlyNumeric','onlyDigital']
    },
    {
      code: 'le',
      name: 'Less than or equals to',
      validFor:['onlyNumeric','onlyDigital']
    },
    {
      code: 'ge',
      name: 'Greater than or equals to',
      validFor:['onlyNumeric','onlyDigital']
    },
    {
      code: 'ne',
      name: 'Not equals to',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars','onlyNumeric','onlyDigital']
    },
    {
      code: 'eq',
      name: 'Equals to',
      validFor:['onlyAlpha', 'alphaNumeric', 'alphaNumericSpecialChars','onlyNumeric','onlyDigital']
    },
    {
      code: 'blk',
      name: 'Is Blank',
      validFor:['*'],
      hideInputValue: true
    },
    ,
    {
      code: 'nbl',
      name: 'Is Not Blank',
      validFor:['*'],
      hideInputValue: true
    },
    {
      code: 'btw',
      name: 'Between',
      validFor:['onlyRange'],
      hideInputValue: false
    }
  ]
  
  
  export const Operatorsign = [
    {
      code: '%',
      name: 'Like'
    },
    {
      code: '<',
      name: 'Less than'
    },
    {
      code: '>',
      name: 'Greater than'
    },
    {
      code: '<=',
      name: 'Less than or equals to'
    },
    {
      code: '>=',
      name: 'Greater than or equals to'
    },
    {
      code: '<>',
      name: 'Not equals to'
    },
    {
      code: '=',
      name: 'Equals to'
    }
  ]
  